import { validateEmail } from './validator';

export const syncValidation = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!validateEmail(values.email)) {
    errors.email = 'Wrong email format';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  if (values.password && values.password.length < 8) {
    errors.password = 'Password min length 8 symbols';
  }

  if (!values.repeatPassword) {
    errors.repeatPassword = 'Required';
  }

  if (values.repeatPassword && values.password && values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Password fields must be the same';
  }

  return errors;
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const asyncValidation = (values) =>
  sleep(1000) // simulate server latency
    .then(() => {
      if (['test@gmail.com'].includes(values.email)) {
        // eslint-disable-next-line no-throw-literal
        throw { email: 'That email is taken' };
      }
    });



// WEBPACK FOOTER //
// ./utils/registrationValidator.js